$(function(){

    $('.faq_content').wrapAll('<div class="faq_content_wrap"></div>');
    $('.faq_content_wrap').before('<div class="faq_category"><p class="fs25">Need help?</p><div class="faq_category_scr"><ul></ul></div></div>');
    $('.faq_content_wrap, .faq_category').wrapAll('<div class="faq_wrap"></div>')

    $(".faq_content").each(function() {
        const faq_section_title = $(this).find('>strong').text();
        $('.faq_category ul').append('<li class="fs25">'+faq_section_title+'</li>');
    });

    $('.faq_content ul li p.question').click(function(){
        $(this).find('.toggle_btn').toggleClass('on');
        $(this).next('.answer').slideToggle();
    })

    $('.faq_category li').click(function(){
        const faq_cate_idx = $(this).index();
        const faq_cont_top = $('.faq_content').eq(faq_cate_idx).offset().top - 95;
        $("html, body").animate({scrollTop: faq_cont_top+'px' }, 500);
        
    })

})